export const FETCH_LAB_RESULTS_SUCCESS = 'FETCH_LAB_RESULTS_SUCCESS';
export const FETCH_LAB_RESULTS_FAIL ='FETCH_LAB_RESULTS_FAIL';
export const FETCH_LAB_RESULTS_START = 'FETCH_LAB_RESULTS_START';

export const CREATE_LAB_RESULT_START = 'CREATE_LAB_RESULT_START';
export const CREATE_LAB_RESULT_SUCCESS = 'CREATE_LAB_RESULT_SUCCESS';
export const CREATE_LAB_RESULT_FAIL = 'CREATE_LAB_RESULT_FAIL';
